import { Container } from '@hg/stylizator/components'
import { Text } from '@hg/stylizator/typography'
import { Spacing } from '@hg/stylizator/utils'
import * as React from 'react'

import { IAttributes } from './index'

interface IProps extends IAttributes {
  innerBlocks: React.ReactElement
}

const FAQSectionComponent: React.FC<IProps> = (props) => (
  <>
    <Spacing top={12} compactTop={6} />
    <Container
      widths={{
        largeDesktop: 744,
        desktop: 744,
        tablet: 618,
        mobile: 512,
      }}
    >
      <Text type="heading_large" useCompact align="center">
        <h2>{props.title}</h2>
      </Text>
      <Spacing top={[9, 8]} />
      {props.innerBlocks}
      <Spacing top />
      <Text type="body" useCompact align="center">
        <p dangerouslySetInnerHTML={{ __html: props.footer }} />
      </Text>
      <Spacing top={[8, 5]} />
    </Container>
  </>
)

export default FAQSectionComponent
